import ContractParametersRequest from './contract-parameters-request';

export default class ContractRuleRequest {
  ruleId: string;

  itemRuleId: string;

  name: string;

  ruleGroupId: string;

  parameters: ContractParametersRequest[] = [];

  constructor(obj: any = {}) {
    this.ruleId = obj.id || '';
    this.itemRuleId = obj.itemRuleId || '';
    this.name = obj.name || '';
    this.ruleGroupId = obj.ruleGroupId;
    this.parameters = ContractParametersRequest.ofList(obj.parameters);
  }

  public static of(obj: any = {}): ContractRuleRequest {
    return new ContractRuleRequest(obj || {});
  }

  public static ofList(obj: any[]): ContractRuleRequest[] {
    return obj.map(this.of);
  }
}
